import get from 'lodash/get';
import replace from 'lodash/replace';
import {
  distributionChannels,
  EnvironmentTypes,
  getEnvironment,
  getLocale,
  getServiceBaseURL,
  isCSR,
  LocaleKey,
} from '@raisin/cp-utils';
import apiRoutes, {
  COUNTRY_CODE,
  DISTRIBUTION_CHANNEL_ID_RAISIN,
  LOCALE,
  UNDERSCORE_LOCALE,
} from './apiRoutes';
import createClient from './createClient';
import { getMicroserviceBaseUrl, getMicroserviceBaseUrlServer } from './microservicesConfig';
import { MICROSERVICES_NAMES } from './types';

const OBS_API_BASE_URL = isCSR() ? `${window.location.origin}/savingglobal/rest/open_api/v2` : '';
const DBS_API_BASE_URL = isCSR() ? getMicroserviceBaseUrl(MICROSERVICES_NAMES.DBS) : '';
const VARIFY_API_BASE_URL = isCSR() ? getMicroserviceBaseUrl(MICROSERVICES_NAMES.VARIFY) : '';
export const integrationSerApiBaseUrl = (version = 'v1') => {
  if (isCSR()) {
    return getEnvironment() === EnvironmentTypes.LOCAL
      ? `https://api2.dev-raisin.com/wjis/${version}`
      : getServiceBaseURL(MICROSERVICES_NAMES.IS, undefined, version);
  }

  return '';
};

export const METHODS = {
  GET: 'get',
  PUT: 'put',
  POST: 'post',
};

const sleep = async (sleepTime = 500) => {
  await new Promise((resolve) => setTimeout(resolve, sleepTime));
};

const AXIOS_CLIENTS = {
  [MICROSERVICES_NAMES.OBS]: createClient(OBS_API_BASE_URL),
  [MICROSERVICES_NAMES.DBS]: createClient(DBS_API_BASE_URL),
  [MICROSERVICES_NAMES.VARIFY]: createClient(VARIFY_API_BASE_URL),
  [MICROSERVICES_NAMES.IS]: createClient(integrationSerApiBaseUrl()),
};

const getUrl = (apis, path, locale) => {
  const urlWithPlaceholders = get(apis, path);

  const urlWithCountryCode = replace(
    urlWithPlaceholders,
    new RegExp(COUNTRY_CODE, 'g'),
    getLocale(locale)?.iso3,
  );

  const urlWithDistributionChannelId = replace(
    urlWithCountryCode,
    DISTRIBUTION_CHANNEL_ID_RAISIN,
    distributionChannels[locale],
  );

  return replace(urlWithDistributionChannelId, UNDERSCORE_LOCALE, getLocale(locale)?.tmsFormat);
};

const getMockUrl = (apis, path, locale) => {
  const urlWithPlaceholders = get(apis, path);

  return replace(urlWithPlaceholders, LOCALE, locale);
};

export const createAsyncAction = async (
  locale: string,
  client: MICROSERVICES_NAMES,
  path: string,
  method = METHODS.GET,
  settings?: any,
) => {
  if (
    !process.env.NEXT_PUBLIC_ENVIRONMENT_NAME ||
    process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === EnvironmentTypes.LOCAL ||
    getEnvironment() === EnvironmentTypes.LOCAL
  ) {
    await sleep(800);
    return import(`../__mocks__${getMockUrl(apiRoutes.local, path, locale)}`).then(
      (res) => res.default,
    );
  }
  const url = getUrl(apiRoutes.production, path, locale);
  // some url manuplation is happening in axios.interceptors.request, any changes here might effect interceptor
  const fullUrl = isCSR() ? url : getMicroserviceBaseUrlServer(client, locale as LocaleKey)(url);
  if (method === METHODS.POST || method === METHODS.PUT) {
    return AXIOS_CLIENTS[client][method](fullUrl, settings?.params, {
      headers: settings?.headers,
      pathParams: settings?.pathParams,
    });
  }

  return AXIOS_CLIENTS[client][method](fullUrl, settings);
};
